class ProgramSponsor {
    
}
ProgramSponsor.schema = {
    "type": "object",
    "properties": {}
}
export default ProgramSponsor;